import { render, staticRenderFns } from "./SveiConfigurazionePuntiIncontroView.vue?vue&type=template&id=85a290d0"
import script from "./SveiConfigurazionePuntiIncontroView.vue?vue&type=script&lang=js"
export * from "./SveiConfigurazionePuntiIncontroView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports